import React, { useState,useEffect } from "react";
import { Link } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import icon from "../assets/images/icona.png";
import home_img from '../assets/images/home/background_slide.jpg'
import blue from '../assets/images/home/blue_paper.png';
import brown from '../assets/images/home/brown_paper.png';
import light from '../assets/images/home/light_paper.png';
import green from '../assets/images/home/green_paper.png';
import purple from '../assets/images/home/purple_paper.png';
import red from '../assets/images/home/red_paper.png';
import base from '../assets/images/home/base.png';
import lights from '../assets/images/home/lights.png';
import light_shadow from '../assets/images/home/light_paper_ref.png';
const Section = ({ leftSide, home = false }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    // Trigger animation when the component mounts
    const timer = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const animatedCol = document.getElementById("animatedCol");
    if (!animatedCol) return;
  
    let animationFrameId;
    let baseX = 0; // Base X position for self-movement
    let baseY = 0; // Base Y position for self-movement
    let mouseOffsetX = 0; // Offset for mouse movement
    let mouseOffsetY = 0;
  
    // Scale factor based on viewport width (smaller screens = smaller movement)
    const scaleFactor = Math.max(0.3, Math.min(1, window.innerWidth / 1920));
  
    // Rectangle boundaries (scaled for viewport)
    const RECT_WIDTH = 300 * scaleFactor; // Width of rectangle
    const RECT_HEIGHT = 200 * scaleFactor; // Height of rectangle
    const RECT_CENTER_X = window.innerWidth / 4; // Center X (relative to window)
    const RECT_CENTER_Y = window.innerHeight / 4; // Center Y (relative to window)
  
    // Self-movement: Oscillates the element
    const selfMove = () => {
      baseX = Math.sin(Date.now() * 0.002) * 50 * scaleFactor; // Scaled horizontal oscillation
      baseY = Math.cos(Date.now() * 0.002) * 50 * scaleFactor; // Scaled vertical oscillation
  
      // Combine self-movement and mouse offsets
      const rawX = RECT_CENTER_X + baseX + mouseOffsetX;
      const rawY = RECT_CENTER_Y + baseY + mouseOffsetY;
  
      // Apply constraints to keep within rectangle bounds
      const finalX = Math.max(
        RECT_CENTER_X - RECT_WIDTH / 2,
        Math.min(RECT_CENTER_X + RECT_WIDTH / 2, rawX)
      );
      const finalY = Math.max(
        RECT_CENTER_Y - RECT_HEIGHT / 2,
        Math.min(RECT_CENTER_Y + RECT_HEIGHT / 2, rawY)
      );
  
      // Apply transformation
      animatedCol.style.transform = `translate(${finalX - RECT_CENTER_X}px, ${finalY - RECT_CENTER_Y}px)`;
  
      // Request the next animation frame
      animationFrameId = requestAnimationFrame(selfMove);
    };
  
    // Adjust position to move away from the cursor
    const handleMouseMove = (event) => {
      const mouseX = event.clientX;
      const mouseY = event.clientY;
  
      // Calculate direction opposite to cursor (scaled)
      const deltaX = (RECT_CENTER_X - mouseX) * 0.1 * scaleFactor;
      const deltaY = (RECT_CENTER_Y - mouseY) * 0.1 * scaleFactor;
  
      mouseOffsetX = deltaX;
      mouseOffsetY = deltaY;
    };
  
    const handleMouseLeave = () => {
      // Reset offset when the mouse leaves
      mouseOffsetX = 0;
      mouseOffsetY = 0;
    };
  
    // Start the animation
    selfMove();
    
    if (window.innerWidth < 786){
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseleave", handleMouseLeave);
      return 
    }
    // Attach mouse event listeners
    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseleave", handleMouseLeave);
  
    // Cleanup on unmount
    return () => {
      cancelAnimationFrame(animationFrameId);
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, []);
  return (
    <React.Fragment>
      <section className={!home ? "bg-home" : "bg-home-2"} id="home">
        <div className="bg-overlay"></div>
        <div className="m-0 container-fluid p-0">
          <div className="row align-items-center justify-content-center m-0">
            {!home ? (
              <>
                <Col
                  xs={3}
                  lg={2}
                  className="text-center text-primary"
                  style={{
                    transform: `translateX(${loaded ? "0" : "-100%"})`,
                    transition: "transform 1s ease-in-out",
                  }}
                >
                  <img src={icon} alt="icon"></img>
                </Col>
                <Col
                  xs={6}
                  lg={3}
                  className={`text-center text-primary title-text`}
                  style={{
                    transform: `translateX(${loaded ? "0" : "-100%"})`,
                    transition: "transform 1.2s ease-in-out",
                  }}
                >
                  {leftSide}
                </Col>
              </>
            ) : (
              <>
                <div
                  style={{
                    position: "relative",
                    display: "inline-block",
                    margin: 0,
                    padding: 0,
                    objectFit: "cover",
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={home_img}
                    alt="home"
                    style={{
                      objectFit: "fill",
                      height: "auto",
                      width: "100%",
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      top: "30%",
                      left: "5%",
                      transform: `translateY(-50%) translateX(${
                        loaded ? "0" : "-100%"
                      })`,
                      transition: "transform 1s ease-in-out",
                      color: "white",
                      textAlign: "left",
                    }}
                  >
                    <Col xl={6} lg={8} md={8} xs={9}>
                      {leftSide}
                    </Col>
                  </div>
                  <div
                    style={{
                      position: "absolute",
                      top: "95%",
                      left: "15%",
                      right: "5%",
                      transform: `translateY(-50%) translateX(${
                        loaded ? "0" : "100%"
                      })`,
                      transition: "transform 1.5s ease-in-out",
                      color: "white",
                      textAlign: "left",
                    }}
                  >
                    <div className="row">
                      {[blue, red, green, purple].map((src, index) => (
                        <div
                          key={index}
                          className={`col-2 p-0 ${window.innerWidth < 768 ? "mt-5 pt-4" : ""}`} // Add 'mt-3' for mobile screens
                          style={{
                            opacity: loaded ? 1 : 0,
                            transform: `translateY(${loaded ? "0" : "20px"})`,
                            transition: `opacity ${1 + index * 0.1}s ease, transform ${
                              1 + index * 0.1
                            }s ease`,
                          }}
                        >
                          <img src={src} alt={`img ${index}`} className="responsive-img" />
                        </div>
                      ))}

                      <div
                        id="animatedCol"
                        className={`col-2 p-0 ${window.innerWidth < 768 ? "mt-5" : ""}`} // Add 'mt-3' for mobile screens
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "flex-start",
                          marginTop: "-150px",
                          animation: "float 2s ease-in-out infinite",
                          opacity: loaded ? 1 : 0,
                          transform: `translateY(${loaded ? "0" : "20px"})`,
                          transition: "opacity 1.5s ease, transform 1.5s ease",
                        }}
                      >
                        <div className="row justify-content-center">
                          <img src={light} className="col-12 responsive-img"></img>
                          <img src={base} className="col-12 w-50 responsive-img"></img>
                          <img src={light_shadow} className="col-12 m-5 responsive-img"></img>
                        </div>
                      </div>

                      <div
                        key={5}
                        className={`col-2 p-0 ${window.innerWidth < 768 ? "mt-5 pt-4" : ""}`} // Add 'mt-3' for mobile screens
                        style={{
                          opacity: loaded ? 1 : 0,
                          transform: `translateY(${loaded ? "0" : "20px"})`,
                          transition: `opacity ${1 + 5 * 0.1}s ease, transform ${
                            1 + 5 * 0.1
                          }s ease`,
                        }}
                      >
                        <img src={brown} alt={`img 5`} className="responsive-img" />
                      </div>
                    </div>
                    </div>
                </div>
              </>
            )}
          </div>
        </div>
      </section>
      {/* <!-- END HOME --> */}
      {/* <!-- START SHAPE --> */}
      <div className="position-relative">
        <div className="shape">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="1440"
            height="150"
            preserveAspectRatio="none"
            viewBox="0 0 1440 150"
          >
            <g mask='url("#SvgjsMask1022")' fill="none">
              <path
                d="M 0,58 C 144,73 432,131.8 720,133 C 1008,134.2 1296,77.8 1440,64L1440 250L0 250z"
                fill="rgba(255, 255, 255, 1)"
              ></path>
            </g>
            <defs>
              <mask id="SvgjsMask1022">
                <rect width="1440" height="250" fill="#ffffff"></rect>
              </mask>
            </defs>
          </svg>
        </div>
      </div>
      {/* <!-- END SHAPE --> */}
    </React.Fragment>
  );
};

export default Section;
